/* window.BotRewards на React: тот же контракт страниц PAGES, что у assets/bot-rewards.js (init, mount, unmount, mounted, S, fill, after, PREFIX, TESTS, summary).
   Ставится на место bot-rewards.js в порядке скриптов (src/legacy/replaced.json → @bot-rewards в манифесте). */
import { definePageModule } from '../../bridge/page-module';
import { createRuntime } from './runtime';
import { Rewards } from './Rewards';
import { storyOpen, toPt } from './actions';
import { isServerMode } from '../../platform/server-mode';
import { serveStories } from '../../bridge/partner-ref';
import { emptyView, srvLoad, srvWatch } from './rewards-server';

/** [ТЕСТ] меню «Состояния»: группа «Награды и задания» (флаги rw…; уровень партнёра — флагами «Партнёрства» pt…) */
const TESTS: [string, [string, string][]][] = [
  [
    'Награды и задания',
    [
      ['Награды: ежедневные', 'rewards'],
      ['Награды: сегодня забрано', 'rewards.rwclaimed'],
      ['Награды: челлендж выполнен', 'rewards.rwweek'],
      ['Награды: разовые', 'rewards.rwone'],
      ['Награды: лист сторис', 'rewards.rwstory'],
      ['Награды: сторис отправлена', 'rewards.rwstoryok'],
      ['Награды: вход через STEOS ID', 'rewards.rwsid'],
      ['Награды: STEOS ID подключён', 'rewards.rwone.ptsid'],
      ['Награды: друзья', 'rewards.rwfr'],
      ['Награды: друзья, уровень Продвинутый', 'rewards.rwfr.ptlvl2'],
      ['Награды: друзья, Амбассадор', 'rewards.rwfr.ptlvl3'],
      ['Награды: новый пользователь', 'rewards.rwnew.ptnew'],
      ['Награды: новый пользователь, друзья', 'rewards.rwfr.rwnew.ptnew'],
      ['Награды: партнёрский блок', 'rewards.rwpt'],
      ['Награды: партнёрский блок, Амбассадор', 'rewards.rwpt.ptlvl3'],
      ['Награды: промокод скопирован', 'rewards.rwcopied'],
      ['Награды: тёмная', 'rewards.dark'],
      ['Награды: друзья, тёмная', 'rewards.rwfr.dark'],
      ['Награды: промокод скопирован, тёмная', 'rewards.rwcopied.dark'],
    ],
  ],
];

/** Серверный режим: задания и серия только с сервера (демо-задания убраны), снимок нужен и меню «Ещё» до открытия раздела */
function startServer(r: ReturnType<typeof createRuntime>) {
  r.TASKS.splice(0);
  r.store.S.srv = emptyView();
  serveStories();
  void srvLoad();
}

export function installRewards() {
  const srv = isServerMode();
  const r = createRuntime();
  const { BC, store } = r;
  const S = store.S;
  if (srv) startServer(r);

  /* вход через STEOS ID — в листе задания или в любом разделе: задание становится «Забрать», если страница на экране.
     С сервером состояние задания знает только сервер — снимок перечитывается */
  BC.sid.on(() => {
    if (srv) return void srvLoad();
    if (!r.mounted) return;
    r.popAfter.set('sid', '.rw-take');
    store.update(() => {});
  });

  /* блок ссылки и промокода — разметка ядра (BotCore.ref.html): его кнопки обрабатываются так же, как в прототипе */
  document.addEventListener('click', e => {
    if (!r.mounted) return;
    const t = (e.target as Element | null)?.closest<HTMLElement>('[data-rf-copy],[data-rf-share]');
    const root = document.getElementById('rewards');
    if (!t || !root || !root.contains(t)) return;
    if (t.dataset.rfCopy) BC.ref.copy(t, BC.ref.hooks(r.ui, S));
    else BC.ref.share(t, BC.ref.hooks(r.ui, S));
  });

  definePageModule({
    global: 'BotRewards',
    PREFIX: 'rw',
    TESTS: srv ? [] : TESTS,
    S,
    Page: Rewards,
    init(o) {
      Object.assign(r.ui, o);
    },
    fill(k) {
      if (srv) return;
      if (k === 'rwone' || k === 'rwfr') S.tab = k.slice(2) as 'one' | 'fr';
      else if (k === 'rwclaimed') {
        S.today = true;
        S.streak = 4;
      } else if (k === 'rwweek') S.pg.wcircles = 10;
      else if (k === 'rwstory') {
        S.tab = 'one';
        S.story = true;
      } else if (k === 'rwstoryok') {
        S.tab = 'one';
        S.pg.story = 1;
      } else if (k === 'rwsid') {
        S.tab = 'one';
        S.sid = true;
      } else if (k === 'rwnew') {
        S.streak = 0;
        S.today = false;
        Object.keys(S.pg).forEach(x => (S.pg[x] = 0));
        S.got.clear();
      } else if (k === 'rwpt') S.toPt = true;
      else if (k === 'rwcopied') {
        S.copied = 'code';
        S.hold = true;
        S.toPt = true;
      }
    },
    after() {
      if (!r.mounted) return;
      if (S.toPt) {
        S.toPt = false;
        toPt();
      }
      if (S.story) {
        S.story = false;
        storyOpen();
      }
      if (S.sid) {
        S.sid = false;
        BC.sid.link();
      }
    },
    onMount: () => {
      r.mounted = true;
      if (!srv) return;
      void srvLoad();
      srvWatch(true);
    },
    beforeUnmount() {
      BC.story.close();
      BC.sid.close();
      if (!S.hold) S.copied = '';
      r.mounted = false;
      if (srv) srvWatch(false);
    },
    extra: { summary: () => r.c.summary() },
  });
}
